var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackSuggestionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.0574 10.0013C3.79774 9.41443 3.66376 8.77972 3.66406 8.13797C3.66406 5.6693 5.60406 3.66797 7.9974 3.66797C10.3907 3.66797 12.3307 5.66997 12.3307 8.13864C12.3309 8.78016 12.197 9.41463 11.9374 10.0013",
    stroke: "#5A5A5A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.33398V2.00065M14.6654 8.00065H13.9987M1.9987 8.00065H1.33203M12.712 3.28598L12.2407 3.75732M3.7567 3.75798L3.28536 3.28665M9.6767 12.8713C10.35 12.6533 10.6207 12.0367 10.6967 11.4167C10.7194 11.2313 10.5667 11.0773 10.38 11.0773H5.65003C5.60445 11.0766 5.55923 11.0856 5.51737 11.1036C5.4755 11.1217 5.43795 11.1484 5.4072 11.1821C5.37644 11.2157 5.35318 11.2555 5.33896 11.2988C5.32474 11.3421 5.31988 11.388 5.3247 11.4333C5.39936 12.052 5.58736 12.5047 6.3007 12.8713M9.6767 12.8713H6.3007M9.6767 12.8713C9.59603 14.168 9.22136 14.6813 8.00336 14.6667C6.7007 14.6907 6.4007 14.056 6.3007 12.8713",
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSuggestionIcon);
export default __webpack_public_path__ + "static/media/feedback-suggestion-icon.20809c9d0d9d432e425ca9b36035fa66.svg";
export { ForwardRef as ReactComponent };